import { type Booking, type BookingClient } from '../../../models/Scheduling'
import { clientDisplayName, clientKey } from '../shared/schedulingDisplay'

export interface ClientInviteLink {
  name: string
  url: string
}

export const clientInviteUrl = (booking: Booking, client: BookingClient): string | undefined => {
  const key = clientKey(client)
  return key === '' ? undefined : booking.clients.find((candidate) => clientKey(candidate) === key)?.inviteUrl
}

export const withDraftInviteUrls = (clients: BookingClient[], draft: Booking | null): BookingClient[] =>
  clients.map((client) => {
    const inviteUrl = draft ? clientInviteUrl(draft, client) : undefined
    return inviteUrl ? { ...client, inviteUrl } : client
  })

export const collectClientInviteLinks = (clients: BookingClient[]): ClientInviteLink[] =>
  clients.flatMap((client) => (client.inviteUrl ? [{ name: clientDisplayName(client), url: client.inviteUrl }] : []))

export const formatClientInviteLinks = (links: ClientInviteLink[]): string =>
  links.length === 1 ? links[0].url : links.map(({ name, url }) => `${name} - ${url}`).join('\n')
